import React, { memo, FC } from "react";
import {
  Checkbox,
  FormGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
  Divider,
  Typography,
} from "@mui/material";
import ReusableAccordian from "../ReusableAccordion";
import DLselection from "../lites/DLselection";
import { Image } from "cloudinary-react";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import useDLSelection2 from "./useDLSelection2";

const StyledFormControl = styled(FormControl)({
  marginBottom: 10,
  marginTop: 20,
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
});

const DLAccordian: FC = () => {
  const {
    handleCheck,
    displayedDl,
    text,
    materialChoice,
    daylightOpening,
    dlLayout,
    dlLayoutSidelite,
    sideliteSdl,
    swingSidelite,
    equalPanelsChecked,
    addDL,
    handleCheckComboMatch,
    isCombo,
    comboMatchHorizontalSdlBars,
    liteConfig,
    sdlExteriorShape,
  } = useDLSelection2();

  return (
    <ReusableAccordian
      accordionName="dl"
      heading={text}
      secondaryHeading={`Select ${text} shape`}
      colOrRow="col"
    >
      <RowLayout>
        <DLselection
          layout={dlLayout}
          dlo={daylightOpening}
          swingSidelite={false}
          panelLayout=""
        />

        <ColLayout>
          {materialChoice.includes("Aluminum") && displayedDl && (
            <ColLayout style={{ marginLeft: 20, marginBottom: 60 }}>
              <div style={{ marginTop: 20 }}>
                <Image
                  cloudName="ag-millworks"
                  secure="true"
                  publicId={displayedDl}
                />
              </div>
            </ColLayout>
          )}
          {materialChoice.includes("Clad") && displayedDl && (
            <ColLayout style={{ marginLeft: 20, marginBottom: 60 }}>
              <Typography variant="caption">
                * Lites shape will match Stickings and Stops profiles
              </Typography>
              <div style={{ marginTop: 20 }}>
                <Image
                  cloudName="ag-millworks"
                  secure="true"
                  publicId={displayedDl}
                />
              </div>
            </ColLayout>
          )}
          {materialChoice === "All Wood" && displayedDl && (
            <ColLayout style={{ marginLeft: 20, marginBottom: 60 }}>
              <Typography variant="caption">
                * Wood Divided Lites shape will match Stickings and Stops
                profiles
              </Typography>
              <div style={{ marginTop: 20 }}>
                <Image
                  cloudName="ag-millworks"
                  secure="true"
                  publicId={displayedDl}
                />
              </div>
            </ColLayout>
          )}
          {!displayedDl &&
            (materialChoice.includes("Clad") && liteConfig === '7/8"' && !sdlExteriorShape ? (
              <RowLayout>
                <Typography variant="body2">
                  *Select a SDL exterior shape to view your overall SDL shape
                </Typography>
              </RowLayout>
            ) : (
              <RowLayout>
                <Typography variant="body2">
                  *Select a Stickings/Stops Profile to view your {text} shape
                </Typography>
              </RowLayout>
            ))}
        </ColLayout>
      </RowLayout>

      {isCombo &&
        addDL !== "Add Intermediate Rail" &&
        !["2W1H", "3W1H", "3W2H", "4W1H", "9 Lite Marginal"].includes(
          dlLayout || "",
        ) && (
          <ColLayout>
            <StyledFormControl>
              <FormLabel style={{ color: "black" }} component="legend">
                Match Horizontal Bars?
                <span style={{ color: "red", fontSize: 22 }}>*</span>
              </FormLabel>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={comboMatchHorizontalSdlBars ? true : false}
                      onChange={(e) => handleCheckComboMatch(e, "yes")}
                    />
                  }
                  label="Yes"
                  labelPlacement="end"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={comboMatchHorizontalSdlBars ? false : true}
                      onChange={(e) => handleCheckComboMatch(e, "no")}
                    />
                  }
                  label="No"
                  labelPlacement="end"
                />
              </FormGroup>
            </StyledFormControl>
          </ColLayout>
        )}

      {swingSidelite &&
        !equalPanelsChecked &&
        addDL !== "Add Intermediate Rail" && (
          <ColLayout>
            <StyledFormControl>
              <FormLabel style={{ color: "black" }} component="legend">
                Would you like the Sidelite SDL Configuration to match?
                <span style={{ color: "red", fontSize: 22 }}>*</span>
              </FormLabel>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      disabled={
                        swingSidelite && dlLayout === "9 Lite Marginal"
                          ? true
                          : false
                      }
                      checked={
                        sideliteSdl === null || sideliteSdl ? false : true
                      }
                      onChange={(e) => handleCheck(e, "yes")}
                    />
                  }
                  label="Yes"
                  labelPlacement="end"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      disabled={
                        swingSidelite && dlLayout === "9 Lite Marginal"
                          ? true
                          : false
                      }
                      checked={
                        sideliteSdl === null || !sideliteSdl ? false : true
                      }
                      onChange={(e) => handleCheck(e, "no")}
                    />
                  }
                  label="No"
                  labelPlacement="end"
                />
              </FormGroup>
            </StyledFormControl>

            {sideliteSdl && sideliteSdl !== null && (
              <>
                <Divider style={{ width: "120%", height: 3 }} />

                <Typography style={{ paddingTop: 20 }}>
                  Select a Sidelite SDL Configuration:
                </Typography>

                <DLselection
                  panelLayout={dlLayout || ""}
                  layout={dlLayoutSidelite}
                  swingSidelite={true}
                />
              </>
            )}
          </ColLayout>
        )}
    </ReusableAccordian>
  );
};

export default memo(DLAccordian);
